import {newShop} from '../shop.js';
import ShippingAddress from '../shipping/ShippingAddress.js';
import Payment from '../payment/Payment.js';
import _ from 'lodash';

newShop.Order = function(orderData){
    "use strict";

    let cartTimestamp;
    let adr;
    let singleFlow;
    let soldToMemberId;
    let distributorName;
    let orderId;
    let externalId;
    let adrOverrideNumber;
    let adrOverrideReason;
    let currencyCode;
    let countryCode;
    let productDiscountCode;
    let productDiscountAmount;
    let shippingDiscountCode;
    let shippingDiscountAmount;
    let selectedDeliveryTimeSlot;
    let reason;
    let locale;
    let sapItems;
    let sapItemQty;

    let selectedAddress;
    let selectedShippingMethod;
    let shippingAvailableMethods;
    let availableAddressTypes;
    let selectedPayment;
    let shippingPayWithPoints;

    let paymentSecurityNumber;
    let paymentClass;
    let paymentOfsId;
    let paymentStatus;
    let availablePayments;
    let custom;
    let orderTotals;
    let orderType;
    let date;
    let outOfStock = [];
    let outOfStockTitle = [];
    let messages;
    let backdating;
    let allowBackdating;
    let backdated;
    let completed;
    let simulateWithoutShipping;
    let externalPayment;
    let errorResponseInfo;
    let paymentAuthorizationObject;
    let giftReceipt;
    let dropShip;
    let externalPaymentAdrNumber;

    let redirectUrl;
    let proxyLaunchUrl;
    let proxyReenterUrl;

    let redirectResponse;
    let idealPaymentObject;

    let pickupPoints;
    let selectedPickupPoint;

    // ---------------------------------------------
    //
    //        Constructor
    //
    // ---------------------------------------------
    if (orderData && orderData !== null) {
        cartTimestamp = orderData.cartTimestamp;
        adr = orderData.adr;
        singleFlow = orderData.singleFlow;
        soldToMemberId = orderData.soldToMemberId;
        distributorName = orderData.distributorName;
        orderId = orderData.orderId;
        externalId = orderData.externalId;
        adrOverrideNumber = orderData.adrOverrideNumber;
        adrOverrideReason = orderData.adrOverrideReason;
        currencyCode =orderData.currencyCode;
        countryCode = orderData.countryCode;
        productDiscountCode = orderData.productDiscountCode;
        productDiscountAmount = orderData.productDiscountAmount;
        shippingDiscountCode = orderData.shippingDiscountCode;
        shippingDiscountAmount = orderData.shippingDiscountAmount;
        reason = orderData.reason;
        locale = orderData.locale;
        selectedDeliveryTimeSlot = orderData.selectedDeliveryTimeSlot;
        paymentSecurityNumber = orderData.paymentSecurityNumber;
        paymentClass = orderData.paymentClass;
        paymentStatus = orderData.paymentStatus;
        paymentOfsId = orderData.paymentOfsId;
        availablePayments = orderData.availablePayments;
        custom = orderData.custom;
        orderTotals = orderData.orderTotals;
        orderType = orderData.orderType;
        date = orderData.date;
        outOfStock = orderData.outOfStock;
        outOfStockTitle = orderData.outOfStockTitle;
        messages = orderData.messages;
        backdating = orderData.backdating;
        allowBackdating = orderData.allowBackdating;
        backdated = orderData.backdated;
        completed = orderData.completed;
        simulateWithoutShipping = orderData.simulateWithoutShipping;
        externalPayment = orderData.externalPayment;
        selectedShippingMethod = orderData.selectedShippingMethod;
        shippingAvailableMethods = orderData.shippingAvailableMethods;
        availableAddressTypes = orderData.availableAddressTypes;
        errorResponseInfo = orderData.errorResponseInfo;
        paymentAuthorizationObject = orderData.paymentAuthorizationObject;
        giftReceipt = orderData.giftReceipt;
        dropShip = orderData.dropShip;
        externalPaymentAdrNumber = orderData.externalPaymentAdrNumber;
        redirectUrl = orderData.redirectUrl;
        proxyLaunchUrl = orderData.proxyLaunchUrl;
        proxyReenterUrl = orderData.proxyReenterUrl;
        redirectResponse = orderData.redirectResponse;
        idealPaymentObject = orderData.idealPaymentObject;
        pickupPoints = orderData.pickupPoints;
        selectedPickupPoint = orderData.selectedPickupPoint;
        shippingPayWithPoints = orderData.shippingPayWithPoints;

        sapItems = orderData.sapItems;
        sapItemQty = orderData.sapItemQty;

        if (orderData.selectedAddress instanceof ShippingAddress) {
            selectedAddress = orderData.selectedAddress;
        } else if (orderData.selectedAddress !== undefined && orderData.selectedAddress !== null) {
            selectedAddress = new ShippingAddress(orderData.selectedAddress);
        }

        if (orderData.selectedPayment instanceof Payment) {
            selectedPayment = orderData.selectedPayment;
        } else if (orderData.selectedPayment !== undefined && orderData.selectedPayment !== null) {
            selectedPayment = new Payment(orderData.selectedPayment);
        }
    }

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    /**
     * Returns true if selectedShippingMethodExists in available methods
     */
    this.syncSelectedShippingMethod = function() {
        let result = false;
        // updated selected shippingmethod
        if (shippingAvailableMethods && selectedShippingMethod) {
            for (let i = 0; i < shippingAvailableMethods.length; i++) {
                //The code isn't enough to differentiate.  You could have two different methods with a code of PU
                if (shippingAvailableMethods[i].Code == selectedShippingMethod.Code &&
                    shippingAvailableMethods[i].PickUpLocation == selectedShippingMethod.PickUpLocation) {

                    selectedShippingMethod = shippingAvailableMethods[i];
                    result = true;
                    break;
                }
            }
        }
        return result;
    };

    this.syncSelectedShippingMethod();

    this.setShippingMethodToTypeofAddress = function(address) {
        let addressType = address.addressType;
        if (addressType !== null){
            const RE = RegExp
            let re = new RE(addressType.substr(0,4),"ig");
            let result = _.find(this.shippingAvailableMethods, function(method) {
                return method.Description.toLowerCase().match(re);
            });

            if(result) {
                this.selectedShippingMethod = result;
            }
        }
    };

    this.getDefaultShipMethod = function(matchMethod = {}) {
        let defaultMethod = null;
        let matchedMethod = null;

        if (shippingAvailableMethods) {
            for (let i = 0; i < shippingAvailableMethods.length; i++) {
                if (!defaultMethod && shippingAvailableMethods[i].Default) {
                    defaultMethod = shippingAvailableMethods[i];
                }
                if (!matchedMethod && shippingAvailableMethods[i].Code === matchMethod.Code) {
                    matchedMethod = shippingAvailableMethods[i];
                }
            }
            // if there is no default ship method in the available methods then select the first ship method
            if (!matchedMethod && !defaultMethod && shippingAvailableMethods.length > 0) {
                defaultMethod = shippingAvailableMethods[0];
            }
        }
        return matchedMethod || defaultMethod;
    };

    this.addOutOfStock = function(outOfStockItem) {
        if (outOfStockItem) {
            outOfStock.push(outOfStockItem);
        }
    };

    this.addOutOfStockTitle = function(outOfStockItemTitle) {
        if (outOfStockItemTitle) {
            outOfStockTitle.push(outOfStockItemTitle);
        }
    };

    this.clearOutOfStock = function() {
        outOfStock = [];
        outOfStockTitle = [];
    };

    this.toJSON = function(){
        let order = {};
        order.cartTimestamp = cartTimestamp;
        order.adr = adr;
        order.singleFlow = singleFlow;
        order.soldToMemberId = soldToMemberId;
        order.distributorName = distributorName;
        order.orderId = orderId;
        order.externalId = externalId;
        order.adrOverrideNumber = adrOverrideNumber;
        order.adrOverrideReason = adrOverrideReason;
        order.currencyCode = currencyCode;
        order.countryCode = countryCode;
        order.productDiscountCode = productDiscountCode;
        order.productDiscountAmount = productDiscountAmount;
        order.shippingDiscountCode = shippingDiscountCode;
        order.shippingDiscountAmount = shippingDiscountAmount;
        order.reason = reason;
        order.locale = locale;
        order.sapItems = sapItems;
        order.sapQty = sapItemQty;
        order.selectedDeliveryTimeSlot = selectedDeliveryTimeSlot;
        order.paymentSecurityNumber = paymentSecurityNumber;
        order.paymentClass = paymentClass;
        order.paymentOfsId = paymentOfsId;
        order.paymentStatus = paymentStatus;
        order.availablePayments = availablePayments;
        order.custom = custom;
        order.orderTotals = orderTotals;
        order.orderType = orderType;
        order.date = date;
        order.outOfStock = outOfStock;
        order.outOfStockTitle = outOfStockTitle;
        order.messages = messages;
        order.backdating = backdating;
        order.allowBackdating = allowBackdating;
        order.backdated = backdated;
        order.completed = completed;
        order.simulateWithoutShipping = simulateWithoutShipping;
        order.externalPayment = externalPayment;
        order.selectedShippingMethod = selectedShippingMethod;
        order.shippingAvailableMethods = shippingAvailableMethods;
        order.availableAddressTypes = availableAddressTypes;
        order.errorResponseInfo = errorResponseInfo;
        order.externalPaymentAdrNumber = externalPaymentAdrNumber;
        order.paymentAuthorizationObject = paymentAuthorizationObject;
        order.giftReceipt = giftReceipt;
        order.dropShip = dropShip;
        order.redirectUrl = redirectUrl;
        order.proxyLaunchUrl = proxyLaunchUrl;
        order.proxyReenterUrl = proxyReenterUrl;
        order.redirectResponse = redirectResponse;
        order.idealPaymentObject = idealPaymentObject;
        order.pickupPoints = pickupPoints;
        order.selectedPickupPoint = selectedPickupPoint;
        order.shippingPayWithPoints = shippingPayWithPoints;

        // workaround for ng-model stripping functions
        if (selectedAddress instanceof ShippingAddress) {
            order.selectedAddress = selectedAddress.toJSON();
        } else {
            order.selectedAddress = selectedAddress;
        }

        if (selectedPayment instanceof Payment) {
            order.selectedPayment = selectedPayment.toJSON();
        } else {
            order.selectedPayment = selectedPayment;
        }

        return order;
    };

    // ---------------------------------------------
    //
    //        Public Getter / Setter Methods
    //
    // ---------------------------------------------
    Object.defineProperties(this, {
        cartTimestamp: {
            get: function() {
                return cartTimestamp;
            },
            set: function(_cartTimestamp) {
                cartTimestamp = _cartTimestamp;
            }
        },
        adr: {
            get: function() {
                return adr;
            },
            set: function(_adr) {
                adr = _adr;
            }
        },
        singleFlow: {
            get: function() {
                return singleFlow;
            },
            set: function(_singleFlow) {
                singleFlow = _singleFlow;
            }
        },
        soldToMemberId: {
            get: function() {
                return soldToMemberId;
            },
            set: function(_soldToMemberId) {
                soldToMemberId = _soldToMemberId;
            }
        },
        distributorName: {
            get: function() {
                return distributorName;
            },
            set: function(_distributorName) {
                distributorName = _distributorName;
            }
        },
        orderId: {
            get: function() {
                return orderId;
            },
            set: function(_orderId) {
                orderId = _orderId;
            }
        },
        externalId: {
            get: function() {
                return externalId;
            },
            set: function(_externalId) {
                externalId = _externalId;
            }
        },
        adrOverrideNumber: {
            get: function() {
                return adrOverrideNumber;
            },
            set: function(_adrOverrideNumber) {
                adrOverrideNumber = _adrOverrideNumber;
            }
        },
        adrOverrideReason: {
            get: function() {
                return adrOverrideReason;
            },
            set: function(_adrOverrideReason) {
                adrOverrideReason = _adrOverrideReason;
            }
        },
        currencyCode: {
            get: function() {
                return currencyCode;
            },
            set: function(_currencyCode) {
                currencyCode = _currencyCode;
            }
        },
        countryCode: {
            get: function() {
                return countryCode;
            },
            set: function(_countryCode) {
                countryCode = _countryCode;
            }
        },
        productDiscountCode: {
            get: function() {
                return productDiscountCode;
            },
            set: function(_productDiscountCode) {
                productDiscountCode = _productDiscountCode;
            }
        },
        productDiscountAmount: {
            get: function() {
                return productDiscountAmount;
            },
            set: function(_productDiscountAmount) {
                productDiscountAmount = _productDiscountAmount;
            }
        },
        shippingDiscountCode: {
            get: function() {
                return shippingDiscountCode;
            },
            set: function(_shippingDiscountCode) {
                shippingDiscountCode = _shippingDiscountCode;
            }
        },
        shippingDiscountAmount: {
            get: function() {
                return shippingDiscountAmount;
            },
            set: function(_shippingDiscountAmount) {
                shippingDiscountAmount = _shippingDiscountAmount;
            }
        },
        reason: {
            get: function() {
                return reason;
            },
            set: function(_reason) {
                reason = _reason;
            }
        },
        locale: {
            get: function() {
                return locale;
            },
            set: function(_locale) {
                locale = _locale;
            }
        },
        sapItems: {
            get: function() {
                return sapItems;
            },
            set: function(_sapItems = []) {
                sapItems = _sapItems;
            }
        },
        sapItemQty: {
            get: function() {
                return sapItemQty;
            },
            set: function(_sapItemQty = 0) {
                sapItemQty = _sapItemQty;
            }
        },
        selectedAddress: {
            get: function() {
                return selectedAddress;
            },
            set: function(_selectedAddress) {
                selectedAddress = _selectedAddress;
            }
        },
        selectedShippingMethod: {
            get: function() {
                return selectedShippingMethod;
            },
            set: function(_selectedShippingMethod) {
                selectedShippingMethod = _selectedShippingMethod;
            }
        },
        shippingAvailableMethods: {
            get: function() {
                return shippingAvailableMethods;
            },
            set: function(_shippingAvailableMethods) {
                shippingAvailableMethods = _shippingAvailableMethods;
            }
        },
        availableAddressTypes: {
            get: function() {
                return availableAddressTypes;
            },
            set: function(_availableAddressTypes) {
                availableAddressTypes = _availableAddressTypes;
            }
        },
        selectedDeliveryTimeSlot: {
            get: function() {
                return selectedDeliveryTimeSlot;
            },
            set: function(_selectedDeliveryTimeSlot) {
                selectedDeliveryTimeSlot = _selectedDeliveryTimeSlot;
            }
        },
        selectedPayment: {
            get: function() {
                return selectedPayment;
            },
            set: function(_selectedPayment) {
                selectedPayment = _selectedPayment;
            }
        },
        shippingPayWithPoints: {
            get: function() {
                return shippingPayWithPoints;
            },
            set: function(_shippingPayWithPoints) {
                shippingPayWithPoints = _shippingPayWithPoints;
            }
        },
        paymentSecurityNumber: {
            get: function() {
                return paymentSecurityNumber;
            },
            set: function(_paymentSecurityNumber) {
                paymentSecurityNumber = _paymentSecurityNumber;
            }
        },
        paymentClass: {
            get: function() {
                return paymentClass;
            },
            set: function(_paymentClass) {
                paymentClass = _paymentClass;
            }
        },
        paymentOfsId: {
            get: function() {
                return paymentOfsId;
            },
            set: function(_paymentOfsId) {
                paymentOfsId = _paymentOfsId;
            }
        },
        availablePayments: {
            get: function() {
                return availablePayments;
            },
            set: function(_availablePayments) {
                availablePayments = _availablePayments;
            }
        },
        custom: {
            get: function() {
                return custom;
            },
            set: function(_custom) {
                custom = _custom;
            }
        },
        orderTotals: {
            get: function() {
                return orderTotals;
            },
            set: function(_orderTotals) {
                orderTotals = _orderTotals;
            }
        },
        orderType: {
            get: function() {
                return orderType;
            },
            set: function(_orderType) {
                orderType = _orderType;
            }
        },
        date: {
            get: function() {
                return date;
            },
            set: function(_date) {
                date = _date;
            }
        },
        outOfStock: {
            get: function() {
                return outOfStock;
            },
            set: function(_outOfStock) {
                if (_outOfStock === '[object Array]'){
                    outOfStock = _outOfStock;
                }
            }
        },
        outOfStockTitle: {
            get: function() {
                return outOfStockTitle;
            },
            set: function(_outOfStockTitle) {
                if (_outOfStockTitle === '[object Array]'){
                    outOfStockTitle = _outOfStockTitle;
                }
            }
        },
        messages: {
            get: function() {
                return messages;
            },
            set: function(_messages) {
                messages = _messages;
            }
        },
        backdating: {
            get: function() {
                return backdating;
            },
            set: function(_backdating) {
                backdating = _backdating;
            }
        },
        allowBackdating: {
            get: function() {
                return allowBackdating;
            },
            set: function(_allowBackdating) {
                allowBackdating = _allowBackdating;
            }
        },
        backdated: {
            get: function() {
                return backdated;
            },
            set: function(_backdated) {
                backdated = _backdated;
            }
        },
        completed: {
            get: function() {
                return completed;
            },
            set: function(_completed) {
                completed = _completed;
            }
        },
        simulateWithoutShipping: {
            get: function() {
                return simulateWithoutShipping;
            },
            set: function(_simulateWithoutShipping) {
                simulateWithoutShipping = _simulateWithoutShipping;
            }
        },
        externalPayment: {
            get: function() {
                return externalPayment;
            },
            set: function(_externalPayment) {
                externalPayment = _externalPayment;
            }
        },
        errorResponseInfo: {
            get: function() {
                return errorResponseInfo;
            },
            set: function(_errorResponseInfo) {
                errorResponseInfo = _errorResponseInfo;
            }
        },
        paymentAuthorizationObject: {
            get: function() {
                return paymentAuthorizationObject;
            },
            set: function(_paymentAuthorizationObject) {
                paymentAuthorizationObject = _paymentAuthorizationObject;
            }
        },
        paymentStatus: {
            get: function() {
                return paymentStatus;
            },
            set: function(_paymentStatus) {
                paymentStatus = _paymentStatus;
            }
        },
        giftReceipt: {
            get: function() {
                return giftReceipt;
            },
            set: function(_giftReceipt) {
                giftReceipt = _giftReceipt;
            }
        },
        dropShip: {
            get: function() {
                return dropShip;
            },
            set: function(_dropShip) {
                dropShip = _dropShip;
            }
        },
        externalPaymentAdrNumber: {
            get: function() {
                return externalPaymentAdrNumber;
            },
            set: function(_externalPaymentAdrNumber) {
                externalPaymentAdrNumber = _externalPaymentAdrNumber;
            }
        },
        redirectUrl: {
            get: function() {
                return redirectUrl;
            },
            set: function(_redirectUrl) {
                redirectUrl = _redirectUrl;
            }
        },
        proxyLaunchUrl: {
            get: function() {
                return proxyLaunchUrl;
            },
            set: function(_proxyLaunchUrl) {
                proxyLaunchUrl = _proxyLaunchUrl;
            }
        },
        proxyReenterUrl: {
            get: function() {
                return proxyReenterUrl;
            },
            set: function(_proxyReenterUrl) {
                proxyReenterUrl = _proxyReenterUrl;
            }
        },
        redirectResponse: {
            get: function() {
                return redirectResponse;
            },
            set: function(_redirectResponse) {
                redirectResponse = _redirectResponse;
            }
        },
        idealPaymentObject: {
            get: function() {
                return idealPaymentObject;
            },
            set: function(_idealPaymentObject) {
                idealPaymentObject = _idealPaymentObject;
            }
        },
        pickupPoints: {
            get: function() {
                return pickupPoints;
            },
            set: function(_pickupPoints) {
                pickupPoints = _pickupPoints;
            }
        },
        selectedPickupPoint: {
            get: function() {
                return selectedPickupPoint;
            },
            set: function(_selectedPickupPoint) {
                selectedPickupPoint = _selectedPickupPoint;
            }
        }
    });
};

export default newShop.Order;
